import { Warehouse } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface LiquidationBadgeProps {
  inventory?: number;
  unit?: string;
}

export const LiquidationBadge = ({ inventory, unit }: LiquidationBadgeProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="default"
            className="bg-gradient-to-r from-red-600 to-red-500 text-white border-0 cursor-help"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Warehouse className="w-3 h-3 ml-1" />
            {inventory ? `מכירת חיסול: ${inventory} ${unit || ''}` : 'מכירת חיסול'}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs p-4" side="bottom">
          <div className="space-y-2">
            <p className="font-semibold text-sm">מהו חיסול מלאי?</p>
            <p className="text-xs leading-relaxed">
              מלאי שנמכר *בפחות* מהמחיר שהיבואן מביא את הסחורה. כדי להיפטר ממנו ולפנות שטח אחסון,
              עלינו לרכוש את כל המלאי שנותר ועל כן יש יעד מינימלי לכמות רכישה כוללת כדי שנמשוך את הסחורה.
            </p>
            <div className="pt-2 border-t text-xs space-y-1">
              <p>✓ המוצר יסופק רק לאחר הגעה ליעד המכירות</p>
              <p>✓ אספקה משוערת: 7 ימים לאחר הגעה ליעד</p>
              <p>✓ החזר מלא אם לא נגיע ליעד</p>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
